<app-loading *ngIf="contentReady"></app-loading>
<div class="container mb-4">
    <div class="row additem-content">
        <h2 class="additemhead"> {{ "New employee" | translate }} </h2>
        <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
            <div class="d-flex flex-column flex-sm-row justify-content-center">
                <div class="col-12 form-container">


                    <div class="form-group">
                        <input class="input" type="text" id="name" formControlName="name"
                            placeholder="{{ 'Name' | translate }}" [(ngModel)]="name" />
                    </div>

                    <div class="form-group">
                        <input class="input" type="text" id="name" formControlName="job_title"
                            placeholder="{{ 'job title' | translate }}" [(ngModel)]="job_title" [ngClass]="{
                'is-invalid':
                data.controls['job_title'].touched &&
                data.controls['job_title'].errors,
                'is-valid':
                data.controls['job_title'].touched &&
                !data.controls['job_title'].errors,
                'is-touched':
                data.controls['job_title'].untouched &&
                !data.controls['job_title'].errors,
            }" />
                    </div>
                    <div class="form-group">
                        <input class="input" type="text" id="name" formControlName="salary"
                            placeholder="{{ 'salary' | translate }}" [(ngModel)]="salary" [ngClass]="{
                'is-invalid':
                data.controls['salary'].touched &&
                data.controls['salary'].errors,
                'is-valid':
                data.controls['salary'].touched &&
                !data.controls['salary'].errors,
                'is-touched':
                data.controls['salary'].untouched &&
                !data.controls['salary'].errors,
            }" />
                    </div>

                    <!-- ✅ National ID -->
                    <div class="form-group">
                        <input class="input" type="text" id="national_id" formControlName="national_id"
                            placeholder="{{ 'grov_id' | translate }}" [(ngModel)]="national_id" />
                    </div>

                    <!-- ✅ Phone -->
                    <div class="form-group">
                        <input class="input" type="text" id="phone" formControlName="phone"
                            placeholder="{{ 'phone' | translate }}" [(ngModel)]="phone" />
                    </div>

                    <!-- ✅ Address -->
                    <div class="form-group">
                        <input class="input" type="text" id="address" formControlName="address"
                            placeholder="{{ 'address' | translate }}" [(ngModel)]="address" />
                    </div>
                    <!-- ✅ Checkbox -->
                    <div class="form-group" style="text-align: justify;">
                        <label>
                            <input type="checkbox" [(ngModel)]="systemAccess" [checked]="systemAccess"
                                (change)="systemAccess = !systemAccess" name="systemAccess" />
                            {{ 'system access' | translate }}
                        </label>
                        <p style="color: red;font-weight: bold;">{{ 'system access mean' | translate }}</p>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="fromsave accont" [disabled]="data.invalid">
                            {{ "Submit" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>